var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClimateChange = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Climate-Change-2--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Climate Change 2 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.43 13a6.12 6.12 0 0 1 -2.9 0.73A6 6 0 0 1 4.58 13l0.66 -0.84a1.47 1.47 0 0 0 0 -1.8l-0.6 -0.79v-1.4a1.48 1.48 0 0 0 -1.08 -1.43l-2 -0.5 0.07 -0.24 2.65 -0.8a2.16 2.16 0 0 0 1.28 -0.82l0.35 -0.47A2.18 2.18 0 0 0 6.27 2l-0.12 -0.36a6.28 6.28 0 0 1 1.38 -0.16 6.11 6.11 0 0 1 3.22 0.92 0.75 0.75 0 0 0 0.79 -1.28A7.65 7.65 0 0 0 7.53 0 7.56 7.56 0 0 0 5 0.43a7.29 7.29 0 0 0 -2.8 1.75 7.46 7.46 0 0 0 -1.88 3A7.49 7.49 0 0 0 0 6.69a8.69 8.69 0 0 0 0 0.89 7.59 7.59 0 0 0 0.56 2.86 4.32 4.32 0 0 0 0.19 0.45l0 0.09a7.63 7.63 0 0 0 2.2 2.65l0.12 0.1 0.06 0a7.59 7.59 0 0 0 8 0.52 0.75 0.75 0 0 0 -0.7 -1.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.63 5.61a0.73 0.73 0 0 0 -0.6 -0.18L10 5.6a0.68 0.68 0 0 0 -0.23 0.07l-1.57 0.78a1.49 1.49 0 0 0 -0.71 1.87l0.3 0.73A1.46 1.46 0 0 0 9.1 10h0.9l0.51 1a0.74 0.74 0 0 0 0.67 0.41 0.55 0.55 0 0 0 0.18 0 0.75 0.75 0 0 0 0.57 -0.73V6.17a0.71 0.71 0 0 0 -0.3 -0.56Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.45 14.1a0.25 0.25 0 0 1 -0.06 -0.16V4.5a4.5 4.5 0 0 0 -9 0v9.44a0.25 0.25 0 0 1 -0.06 0.16 6 6 0 1 0 9.12 0ZM17.89 22a4 4 0 0 1 -2.8 -6.85 1 1 0 0 0 0.3 -0.71V4.5a2.5 2.5 0 0 1 5 0v9.93a1 1 0 0 0 0.3 0.71 4 4 0 0 1 -2.8 6.86Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 16.33a0.23 0.23 0 0 1 -0.11 -0.2V6.5a1 1 0 0 0 -2 0v9.63a0.23 0.23 0 0 1 -0.11 0.2 2 2 0 1 0 2.22 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClimateChange);
export default ForwardRef;